module.exports = __webpack_public_path__ + "img/planting_05@2x.0457ed9.webp";